<template lang="">
    <div class='w-full flex flex-col ' @click="toggleState" >
       


      <div class='flex bg-site-primary  gap-4 items-center   h-auto p-2 '>
  

        <p class='text-lg text-black'> Week {{ weekNr }} </p>

        <div class="flex flex-row gap-5 p-0.5 text-xs" v-if='difference || endWeight'>
      
         <div class=' bg-orange-200 p-1 rounded '> W: {{endWeight}} </div>
         <div v-if='difference'>
          <div v-if='difference === 0'> 0 </div>

<div class="bg-green-300 p-1 rounded " v-if='difference < 0' >+ {{utils.changeOperatorsAndRound(weightDifference)}} {{userUnits.weight}}</div>
<div class="bg-red-300 p-1 rounded" v-else>{{utils.changeOperatorsAndRound(difference)}} {{userUnits.weight}}</div>




</div>
        </div>
         
      </div>
     
      <Transition name="nested">
        <div v-if="state" class='w-full pl-5 pt-1 pb-1'>
  <div  class='w-full  pt-1 p-1 '>
    <div v-for="(day, dayIndex) in week" class='flex flex-col border-b-2 border-blue-200 border-double' :key="dayIndex">
     
      <div class='flex flex-row bg-white p-0.5 justify-between'>
        <div class="flex flex-row gap-2 items-start p-1">
          <div class='text-md '> Day: {{ day.day }} </div>
          <div class='bg-orange-200 p-0.5 rounded text-xs ' v-if='day.weight'> W: {{day.weight}}</div>

          <div v-if="day.weightChange">
          <div class="bg-green-300 p-0.5 rounded text-xs" v-if='day.weightChange > 0.01' >+ {{utils.changeOperatorsAndRound(day.weightChange)}} {{userUnits.weight}}</div>
          <div class="bg-red-300 p-0.5 rounded text-xs" v-else>- {{utils.changeOperatorsAndRound(day.weightChange)}} {{userUnits.weight}}</div>

        </div>
 
        </div>

        <div class="flex items-end gap-1  text-gray-700 " @click.stop>
          <div v-if='!day.weight' class="rounded  p-0.5 font-bold hover:bg-green-300 hover:cursor-pointer "> <v-icon name="bi-plus-square" scale="1" class=" text-green-600 hover:text-green-700" @click='() => setDate(day.day)' />  </div>
          <div class="rounded  p-0.5  hover:bg-red-300 font-bold hover:cursor-pointer "> <v-icon name="bi-trash" scale="1" class=" text-red-600 hover:text-red-700" @click='() => _deleteEntry(day.day)' /> </div>
        </div>
      </div>
    </div>
  </div>
</div>
</Transition>
    </div>
</template>
<script setup>
import { ref } from 'vue';
import { utils } from '@/utils/utils'
import { deleteEntry } from '@/services/UserService';

const state = ref(false);

import { MessageStore } from '@/stores/Messages';
// eslint-disable-next-line no-unused-vars
const messagesStore = MessageStore();

import {ComponentsStore} from '@/stores/ComponentsStore';
// eslint-disable-next-line no-unused-vars
const componentsStore = ComponentsStore();
import { defineEmits, onMounted } from 'vue';


onMounted(() => {
  const isDesktop = window.innerWidth > 900;
  state.value = isDesktop;
})

const emit = defineEmits(['refresh-event'])

const toggleState = () => {
  state.value = !state.value;

  
};




// eslint-disable-next-line no-undef, no-unused-vars
const props = defineProps({
  week: Object,
  weekNr: Number,
  difference: Number,
  endWeight: Number,
  userUnits: Object,
  month: String,
  year: Number,
  monthNumber: String,
});

// eslint-disable-next-line no-undef


function setDate(day){
  let date = new Date(`${props.year}-${props.month}-${day}`);
  let formattedDate = date.toLocaleDateString('en-GB').replace(/\//g, '-');
  componentsStore.changeAddEntryForm();
  componentsStore.addDateToEntry(formattedDate);

}

async function _deleteEntry(day){
  let date = new Date(`${props.year}-${props.month}-${day}`);
  let formattedDate = date.toLocaleDateString('en-GB').replace(/\//g, '-');
  let response = await deleteEntry(formattedDate)
  messagesStore.setMessage(response.message, response.boolean);
  emit('refresh-event')
  
  

}
</script>
<style lang="css"></style>